<div class="regForm px-1">
  <h3 class="pageTitle">REGISTER TO GET STARTED</h3>
  <mat-tab-group animationDuration="0ms" mat-align-tabs="center" #tabGroup>
    <mat-tab label="Delivery Details" *ngIf="showTab1">
        <div class="tabContheader">
          <h5>WELCOME! LET'S GET YOUR ADDRESS.</h5>
        </div>
        <div class="tabContent">
          <form [formGroup]="Information">
                <div fxLayout="row wrap">
                    <div fxLayout="column" fxLayoutAlign="start" fxFlex="100%" fxFlex.gt-sm="50" class="px-1">
                        <div class="matField" class="w-100">
                          <mat-label>Delivery Option</mat-label>
                          <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                              <mat-select formControlName="deliveryOption" id="deliveryOption" (selectionChange)="onDeliveryOptionChange($event)" >
                                <mat-option *ngFor="let option of deliveryOptions" [value]="option.value">{{ option.label }}</mat-option>
                              </mat-select>
                              <mat-error *ngIf="showDeliveryAddress && autocompleteAddressList.length === 0">Enter your address in the search field. As you enter, the predictions are shown. Please select your address from the list and then click the save button.</mat-error>
                          </mat-form-field>
                        </div>
                        <div class="matField" class="w-100">
                          <div *ngIf="showPickupInfo">
                            <mat-label matNativeControl>Pickup Location</mat-label>
                            <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                                <mat-select formControlName="pickupLocation" id="pickupLocation" (selectionChange)="onPickupLocationChange($event, value)">
                                  <mat-option value="All">All Locations</mat-option>
                                  <mat-option *ngFor="let pickupLocation of pickupLocations" [value]="pickupLocation">
                                    {{ pickupLocation.name }}
                                  </mat-option>
                                </mat-select>
                                <span class="pickupLocations" *ngIf="pickupLocError">
                                  Please contact the site administrator
                                </span>
                              </mat-form-field>
                              <ng-container *ngIf="!!featureTags && featureTags['sf_select_pickup_event']">
                                <div class="matField" [ngClass]="{'w-100 mb-5px': showPickupEvents, 'w-100 mb-186': !showPickupEvents}">
                                  <mat-label matNativeControl>Pickup Schedule</mat-label>
                                    <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                                    <mat-select [formControl]="pickupEventControl" id="pickupEvent" (selectionChange)="onPickupEventChange($event, value)" [disabled]="!showPickupEvents">
                                      <mat-option *ngIf="!showPickupEvents" value="" disabled>Select</mat-option>
                                      <mat-option *ngFor="let pickup of pickupEvents" [value]="pickup">
                                        {{ pickup.event_name }}
                                      </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="pickupEventControl.hasError('required')">Select Pickup Location</mat-error>
                                  </mat-form-field>
                                </div>
                                <mat-card class="p-0" *ngIf="showPickupEvents">
                                  <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
                                      <mat-card-title class="m-0"><h3>Pickup Address</h3></mat-card-title>
                                      <a mat-icon-button routerLink="/account/information"></a>
                                  </mat-card-header>
                                  <div class="divider"></div>
                                    <mat-card-content class="p-2 text-muted account-card-content">
                                      <p>{{addressDetails.address_name}}</p>
                                      <p>{{addressDetails.city}}, {{addressDetails.county}}</p>
                                      <p>{{addressDetails.state}} {{addressDetails.zipcode}}</p>
                                      <p><strong>Notes : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{selPickupLocation.location_notes?selPickupLocation.location_notes:''}}</span></p>
                                    </mat-card-content>
                                  </mat-card>
                              </ng-container>
                              <ng-container *ngIf="!!featureTags && !featureTags['sf_select_pickup_event']">
                                <mat-card class="p-0" *ngIf="showPickupAddress">
                                <mat-card-header class="p-1 account-card-title" fxLayoutAlign="space-between center">
                                    <mat-card-title class="m-0"><h3>Pickup Address</h3></mat-card-title>
                                    <a mat-icon-button routerLink="/account/information"></a>
                                </mat-card-header>
                                <div class="divider"></div>
                                  <mat-card-content class="p-2 text-muted account-card-content">
                                    <p>{{addressDetails.address_name}}</p>
                                    <p>{{addressDetails.city}}, {{addressDetails.county}}</p>
                                    <p>{{addressDetails.state}} {{addressDetails.zipcode}}</p>
                                    <p><strong>Delivery Days : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{selPickupLocation.delivery_days ? selPickupLocation.delivery_days.join(', ') : 'Not available'}}</span></p>
                                    <p><strong>Notes : </strong><span  [ngStyle]="{'color': '#C62828'}"> {{selPickupLocation.location_notes?selPickupLocation.location_notes:''}}</span></p>
                                  </mat-card-content>
                                </mat-card>
                              </ng-container>
                          </div> 
                        </div>
                    </div>
                    <div fxFlex="50%" fxFlex.gt-sm="25" class="px-1" *ngIf="showPickupInfo">
                      <agm-map [latitude]="lat" [longitude]="lng" [fullscreenControl]='true' [zoom]="zoom" [disableDefaultUI]="true" [zoomControl]="true" [mapTypeControl]="true">
                        <agm-marker *ngFor="let m of markers; let i = index" (markerClick)="clickedMarker(m.label, i)" [latitude]="m.lat" [longitude]="m.lng" [markerDraggable]="false" (dragEnd)="markerDragEnd(m, $event)">
                          <agm-info-window>
                            <h3>{{m.label}}</h3>
                            <p>{{m.formatAddress}}</p>
                            <p>Delivery Days : <span [ngStyle]="{'color': '#C62828'}">{{m.deliveryDays}}</span></p>
                            <p>Notes : <span [ngStyle]="{'color': '#C62828'}">{{m.notes}}</span></p>
                          </agm-info-window>
                        </agm-marker>
                      </agm-map>
                    </div>
                  </div>
                <div fxLayout="row wrap" fxLayoutAlign="space-between center" *ngIf="showDeliveryAddress"> <!--&& displayDeliveryAddress-->
                  <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <div class="matField" class="w-100" *ngIf="showDeliveryAddress">
                      <mat-label>Search Address</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input #SearchAddressField type="text"
                              placeholder="Enter a location"
                              aria-label="Location"
                              matInput
                              [formControl]="locationControl"
                              [matAutocomplete]="auto" 
                              (input)="searchDeliveryLocation($event)">
                        <mat-error *ngIf="Information.controls.address.errors?.required">Address is required</mat-error>
                        <mat-autocomplete #auto="matAutocomplete">
                          <mat-option *ngFor="let location of autocompleteAddressList" [value]="location.address"
                          (onSelectionChange)="selectedAddressFromList(location, index)">
                            {{location.address}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>location_on</mat-icon>
                      </mat-form-field>
                  </div>
                  </div>
                  <div fxFlex="100" fxFlex.gt-sm="50" class="px-1"></div>
                  <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Address</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input matInput placeholder="Address" formControlName="address" id="address" required>
                        <mat-error *ngIf="Information.controls.address.errors?.required">Address is required</mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Apt, Suite No.</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input matInput placeholder="Optional" formControlName="apt_suite_no" id="apt_suite_no">
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
                  </div>
                  <!-- <div fxFlex="100" fxFlex.gt-sm="50" class="px-1" >
                    <div class="matField" fxFlex="100%">
                      <mat-label>Address Line 2</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input matInput placeholder="Address Line 2" formControlName="address_2">
                      </mat-form-field>
                    </div>
                  </div> -->
                  <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>City</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input matInput placeholder="City" formControlName="city" id="city" required>
                        <mat-error *ngIf="Information.controls.city.errors?.required">City is required</mat-error>
                        <mat-error *ngIf="Information.controls.city.hasError('validation')">
                            {{Information.controls.city.errors.message}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>State</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input matInput placeholder="State" formControlName="state" id="state">
                        <mat-error *ngIf="Information.controls.state.errors?.required">State is required</mat-error>
                        <mat-error *ngIf="Information.controls.state.hasError('validation')">
                            {{Information.controls.state.errors.message}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" fxFlex.gt-sm="25" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Zip Code</mat-label>
                      <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                        <input type="number" inputmode="numeric" matInput (keypress)="validateNumber($event,10)"
                        (paste)="validatePaste($event)" placeholder="Zip Code" pattern="[0-9]*" id="zipcode" formControlName="zipcode">
                        <mat-error *ngIf="Information.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                        <mat-error *ngIf="Information.controls.zipcode.hasError('validation')">
                            {{Information.controls.zipcode.errors.message}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" class="mt-1 register-btn p-1">
                  <button mat-raised-button color="primary" id="continue" (click)="selectTab(1)" [disabled]="isBtnDisabled" >Continue</button>
                </div>
          </form>
        </div>
    </mat-tab>
    <mat-tab label="Information" *ngIf="showTab2">
      <div class="tabContheader">
        <h5>GREAT! NOW ENTER YOUR DELIVERY ADDRESS AND PHONE NUMBER.</h5>
      </div>
      <div class="tabContent">
        <form [formGroup]="registerForm">
              <div>
                <div fxLayout="row wrap" class="registerFormRow">
                  <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>First Name <span class="required-symbol">*</span></mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                        <input matInput placeholder="First name" formControlName="first_name" id="first_name" required>
                        <mat-error *ngIf="registerForm.controls.first_name.errors?.required">First Name is required</mat-error>
                        <mat-error *ngIf="registerForm.controls.first_name.hasError('maxlength')">First Name characters should be within 35</mat-error>
                        <mat-error *ngIf="registerForm.controls.first_name.hasError('validation')">
                            {{registerForm.controls.first_name.errors.message}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Last Name <span class="required-symbol">*</span></mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                        <input matInput placeholder="Last name" formControlName="last_name" id="last_name" required>
                        <mat-error *ngIf="registerForm.controls.last_name.errors?.required">Last Name is required</mat-error>
                        <mat-error *ngIf="registerForm.controls.last_name.hasError('maxlength')">Last Name characters should be within 35</mat-error>
                        <mat-error *ngIf="registerForm.controls.last_name.hasError('validation')">
                            {{registerForm.controls.last_name.errors.message}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Email Address <span class="required-symbol">*</span></mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                        <input type="email" matInput placeholder="Email" autocomplete="off" formControlName="email_id" id="email_id" required>
                        <mat-error *ngIf="registerForm.controls.email_id.errors?.required">Email is required</mat-error>
                        <mat-error *ngIf="registerForm.controls.email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                        <mat-error *ngIf="registerForm.controls.email_id.hasError('validation')">
                            <span class="forGotAlign" [innerHTML]="registerForm.controls.email_id.errors.message | sanitizeHtml"></span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" class="px-1">
                    <div class="matField" fxFlex="100%">
                        <mat-label>Verify Email <span class="required-symbol">*</span></mat-label>
                        <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                          <input type="email" matInput placeholder="Email" autocomplete="off" formControlName="verify_email_id" id="verify_email_id" required>
                          <mat-error *ngIf="registerForm.controls.verify_email_id.errors?.required">Verify Email is required</mat-error>
                          <mat-error *ngIf="registerForm.controls.verify_email_id.hasError('invalidEmail')">Invalid email address</mat-error>
                          <mat-error *ngIf="!!registerForm.controls.verify_email_id.hasError('emailMismatch') && !registerForm.controls.verify_email_id.hasError('invalidEmail')">Email address mismatch! </mat-error>
                        </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Company Name</mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                        <input matInput placeholder="Company Name" formControlName="company" id="company">
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Who referred you?</mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                        <mat-select formControlName="known_by" id="known_by" (selectionChange)="onKnownByChange($event.value)">
                          <mat-option value="" disabled>Select</mat-option>
                          <mat-option *ngFor="let refer of knownBy" [value]="refer.value">{{ refer.label }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="registerForm.controls.known_by.errors?.required">This field is required</mat-error>
                        <mat-error *ngIf="registerForm.controls.known_by.hasError('validation')">
                            {{registerForm.controls.known_by.errors.message}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" class="px-1" *ngIf="showReferralInput">
                   <div class="matField" fxFlex="100%">
                    <mat-label>Referrer Name</mat-label>
                    <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                      <input type="text" matInput formControlName="internal_notes" id="referral_name" placeholder="Enter name" />
                    </mat-form-field>
                   </div>
                  </div>
                  <div fxFlex="100" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Phone Number <span class="required-symbol">*</span></mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                        <input type="tel" matInput placeholder="Phone Number" autocomplete="off" formControlName="phone_number" id="phone_number" required [value]="registerForm.get('phone_number').value | phone: 'US'" maxlength="13" pattern="[0-9\(\)\-\+\s]*">
                        <mat-error *ngIf="registerForm.controls.phone_number.errors?.required">Phone Number is required</mat-error>
                        <mat-error *ngIf="registerForm.controls.phone_number.hasError('minlength')">Phone Number isn't long enough, minimum of 10 characters</mat-error>
                        <mat-error *ngIf="registerForm.controls.phone_number.hasError('numberOnly')">Phone number can only contain digits.</mat-error>
                        <mat-error *ngIf="registerForm.controls.phone_number.hasError('validation')">
                            <span [innerHTML]="registerForm.controls.phone_number.errors.message | sanitizeHtml"></span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div fxFlex="100" class="px-1">
                    <div class="matField" fxFlex="100%">
                      <mat-label>Password <span class="required-symbol">*</span></mat-label>
                      <mat-form-field appearance="outline" class="w-100" FloatLabelType="never">
                          <input [type]="hide ? 'text' : 'password'"  maxlength="20"  matInput autocomplete="off" placeholder="Password" id="password" formControlName="password">
                          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                            <mat-icon>{{ hide ? 'visibility' : 'visibility_off' }}</mat-icon>
                          </button>
                          <mat-error *ngIf="registerForm.controls.password.errors?.required">Password is required</mat-error>
                          <mat-error *ngIf="registerForm.controls.password.hasError('minlength')">Password isn't long enough, minimum of 6 characters</mat-error>
                          <mat-error *ngIf="registerForm.controls.password.hasError('validation')">
                              {{registerForm.controls.password.errors.message}}
                          </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <ng-container *ngIf="!!featureTags && featureTags['sf_enhance_registration']">
                    <div class="text-left p-1 field-align" *ngIf="storedetails1['enable_website_terms_condition']">
                      <h3>Terms and Conditions</h3>
                      <div class="terms-box matField">
                        <div class="terms-content" [innerHTML]="safeHtmlContent">
                        </div>
                        <mat-checkbox class="terms-checkbox" matInput formControlName="terms_and_conditions" id="terms_and_conditions"
                          color="primary" required>            
                          I agreed to the above.
                        </mat-checkbox>
                        <mat-error *ngIf="isTermandConditionRequired" style="font-size: 75%;"> 
                          You must agree to the terms and conditions.
                        </mat-error>
                      </div>
                    </div>
                  </ng-container>
                  
                  <ng-container *ngIf="!!featureTags && !featureTags['sf_enhance_registration']">
                    <div class="text-left w-100 mt-1 p-1" >
                      By clicking Create A New Account, you acknowledge you have read and agreed to our                
                      <a href="{{termsOfUse}}" target="_blank" class="link">
                          <span [ngStyle]="{'color': '#C62828'}">Terms of Use</span>
                      </a>  
                      and              
                      <a href="{{privacyPolicy}}" target="_blank" class="link">
                          <span [ngStyle]="{'color': '#C62828'}">Privacy Policy</span>
                      </a>                                
                    </div>
                  </ng-container>
                  
                  <div class="text-left w-100 mt-1 p-1">
                    <mat-checkbox matInput formControlName="newsletter_subscription" id="newsletter_subscription" color="primary">
                    </mat-checkbox>&nbsp;
                    <mat-label>Email me about special pricing, new items and more.</mat-label>
                    <mat-error *ngIf="registerForm.controls.newsletter_subscription.hasError('validation')">
                        {{registerForm.controls.newsletter_subscription.errors.message}}
                    </mat-error>
                  </div> 
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" *ngIf="isFinishDelivery" class="mt-1 register-btn p-1">
                  <button mat-raised-button color="primary" (click)="selectTab(2)" id="info_continue" [disabled]="isBtnDisabled">Continue</button>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" *ngIf="!isFinishDelivery" class="mt-1 register-btn p-1">
                <button mat-raised-button color="primary" id="info_register" (click)="onRegisterFormSubmit()">Register</button>
            </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="Finish Delivery" *ngIf="showTab3">
      <ng-container *ngIf="!!featureTags && !featureTags['sf_stripe_payment']">
      <div class="tabContheader">
        <h5>Enter Your billing information</h5>
        <p>Please note, you will not be billed until you place your first order</p>
      </div>
      <div class="tabContent">
        <form [formGroup]="creditCardForm" >     
          <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>Billing Address</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="Billing Address" formControlName="address" id="card_address" required>
                  <mat-error *ngIf="creditCardForm.controls.address.errors?.required">Billing Address is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>City</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="City" formControlName="city" id="card_city" required>
                  <mat-error *ngIf="creditCardForm.controls.city.errors?.required">City is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.city.hasError('validation')">
                      {{creditCardForm.controls.city.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>State</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="State" formControlName="state" id="card_state">
                  <mat-error *ngIf="creditCardForm.controls.state.errors?.required">State is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.state.hasError('validation')">
                      {{creditCardForm.controls.state.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>Zip Code</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input inputmode="numeric" matInput (keypress)="validateNumber($event,10)"
                  (paste)="validatePaste($event)" placeholder="Zip Code" pattern="[0-9]*" formControlName="zipcode" id="zipcode">
                  <mat-error *ngIf="creditCardForm.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.zipcode.hasError('validation')">
                      {{creditCardForm.controls.zipcode.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1 payIn">
                <p>PAYMENT INFO</p>
                <label class="label">Payment Method :</label>
            </div>
            <div class="creditCardIn">
              <div fxLayout="row wrap">
                <div fxFlex="100%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>Card number</mat-label>
                    <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100">
                      <input matInput placeholder="Card number" formControlName="number" id="card_number" type="tel" 
                                autocomplete="cc-number" maxlength="19" (input)="changeCreditCardnumber($event)" ccNumber cc-eager-type> 
                      <mat-error *ngIf="creditCardForm.controls.number.errors?.required">Credit Card number is required</mat-error>
                      <mat-error *ngIf="!creditCardForm.controls.number.errors?.required && creditCardForm.controls.number.errors?.ccNumber">Invalid credit card number</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.number.hasError('validation')">
                          {{creditCardForm.controls.number.errors.message}}
                      </mat-error>
                  </mat-form-field>
                  </div>
                </div>  
                <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>Expiration Date</mat-label>
                    <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100 card-details">
                      <input matInput placeholder="MM/YY" formControlName="expiry" id="card_expiry" (input)="onExpirationInput($event)" type="tel" autocomplete="cc-exp" ccExp maxlength="5">
                      <mat-error *ngIf="creditCardForm.controls.expiry.errors?.required">Expiration Date is required</mat-error>
                      <mat-error *ngIf="!creditCardForm.controls.expiry.errors?.required && creditCardForm.controls.expiry.errors?.expDate">Invalid expiration date</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.expiry.errors?.maxlength">Year must contain 2 digits only</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.expiry.hasError('validation')">
                          {{creditCardForm.controls.expiry.errors.message}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>CVC Code</mat-label>
                    <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100">
                      <input matInput placeholder="CVC Code" formControlName="cvc" id="card_cvc" type="password"
                          inputmode="numeric" autocomplete="off" ccCVC maxlength="4" pattern="[0-9]*"> 
                      <mat-error *ngIf="creditCardForm.controls.cvc.errors?.required">CVC is required</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.errors?.minlength">CVC must be at least 3 digits</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.errors?.invalid">Invalid CVC code</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.hasError('numberOnly')">CVC number can only contain digits.</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.hasError('validation')">
                          {{creditCardForm.controls.cvc.errors.message}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-1 register-btn p-1">
          <button mat-raised-button color="primary" id="register" (click)="onRegisterFormSubmit()">Register</button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!!featureTags && featureTags['sf_stripe_payment']">
      <div class="tabContheader">
        <h5>Enter Your billing information</h5>
        <p>Please note, you will not be billed until you place your first order</p>
      </div>
      <ng-container *ngIf="!!featureTags && !featureTags['ftag_cod_and_other_payment_for_sf']">
      <div class="tabContent" *ngIf="!!paymentMethod && paymentMethod ==='authorize_net'">
        <form [formGroup]="creditCardForm" >     
          <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>Billing Address</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="Billing Address" formControlName="address" id="card_address" required>
                  <mat-error *ngIf="creditCardForm.controls.address.errors?.required">Billing Address is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>City</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="City" formControlName="city" id="card_city" required>
                  <mat-error *ngIf="creditCardForm.controls.city.errors?.required">City is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.city.hasError('validation')">
                      {{creditCardForm.controls.city.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>State</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="State" formControlName="state" id="card_state">
                  <mat-error *ngIf="creditCardForm.controls.state.errors?.required">State is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.state.hasError('validation')">
                      {{creditCardForm.controls.state.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>Zip Code</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input inputmode="numeric" matInput (keypress)="validateNumber($event)"
                  (paste)="validatePaste($event)" placeholder="Zip Code" pattern="[0-9]*" formControlName="zipcode" id="zipcode"> 
                  <mat-error *ngIf="creditCardForm.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.zipcode.hasError('validation')">
                      {{creditCardForm.controls.zipcode.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1 payIn">
                <p>PAYMENT INFO</p>
                <label class="label">Payment Method :</label>
            </div>
            <div class="creditCardIn">
              <div fxLayout="row wrap">
                <div fxFlex="100%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>Card number</mat-label>
                    <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100">
                      <input matInput placeholder="Card number" formControlName="number" id="card_number" type="tel" 
                                autocomplete="cc-number" maxlength="19" (input)="changeCreditCardnumber($event)" ccNumber cc-eager-type> 
                      <mat-error *ngIf="creditCardForm.controls.number.errors?.required">Credit Card number is required</mat-error>
                      <mat-error *ngIf="!creditCardForm.controls.number.errors?.required && creditCardForm.controls.number.errors?.ccNumber">Invalid credit card number</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.number.hasError('validation')">
                          {{creditCardForm.controls.number.errors.message}}
                      </mat-error>
                  </mat-form-field>
                  </div>
                </div>  
                <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>Expiration Date</mat-label>
                    <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100 card-details">
                      <input matInput placeholder="MM/YY" formControlName="expiry" id="card_expiry" (input)="onExpirationInput($event)" type="tel" autocomplete="cc-exp" ccExp maxlength="5">
                      <mat-error *ngIf="creditCardForm.controls.expiry.errors?.required">Expiration Date is required</mat-error>
                      <mat-error *ngIf="!creditCardForm.controls.expiry.errors?.required && creditCardForm.controls.expiry.errors?.expDate">Invalid expiration date</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.expiry.errors?.maxlength">Year must contain 2 digits only</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.expiry.hasError('validation')">
                          {{creditCardForm.controls.expiry.errors.message}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>CVC Code</mat-label>
                    <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100">
                      <input matInput placeholder="CVC Code" formControlName="cvc" id="card_cvc" type="password"
                          inputmode="numeric" autocomplete="off" ccCVC maxlength="4" pattern="[0-9]*"> 
                      <mat-error *ngIf="creditCardForm.controls.cvc.errors?.required">CVC is required</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.errors?.minlength">CVC must be at least 3 digits</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.errors?.invalid">Invalid CVC code</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.hasError('numberOnly')">CVC number can only contain digits.</mat-error>
                      <mat-error *ngIf="creditCardForm.controls.cvc.hasError('validation')">
                          {{creditCardForm.controls.cvc.errors.message}}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-1 register-btn p-1">
          <button mat-raised-button color="primary" id="register" (click)="onRegisterFormSubmit()">Register</button>
        </div>
      </div>
      <div class="tabContent" *ngIf="!!paymentMethod && paymentMethod ==='stripe'">
        <form [formGroup]="stripecreditCardForm" ngxStripeCardGroup
        (ngSubmit)="stripeAddCreditCard(stripecreditCardForm)" novalidate [elementsOptions]="elementsOptions">     
          <div fxLayout="row wrap">
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>Billing Address</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="Billing Address" formControlName="address" id="card_address" required>
                  <mat-error *ngIf="creditCardForm.controls.address.errors?.required">Billing Address is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>City</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="City" formControlName="city" id="card_city" required>
                  <mat-error *ngIf="creditCardForm.controls.city.errors?.required">City is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.city.hasError('validation')">
                      {{creditCardForm.controls.city.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>State</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input matInput placeholder="State" formControlName="state" id="card_state">
                  <mat-error *ngIf="creditCardForm.controls.state.errors?.required">State is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.state.hasError('validation')">
                      {{creditCardForm.controls.state.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
              <div class="matField" fxFlex="100%">
                <mat-label>Zip Code</mat-label>
                <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                  <input inputmode="numeric" matInput (keypress)="validateNumber($event)"
                  (paste)="validatePaste($event)" placeholder="Zip Code" pattern="[0-9]*" formControlName="zipcode" id="zipcode"> 
                  <mat-error *ngIf="creditCardForm.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                  <mat-error *ngIf="creditCardForm.controls.zipcode.hasError('validation')">
                      {{creditCardForm.controls.zipcode.errors.message}}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div fxFlex="100" fxFlex.gt-sm="100" class="px-1 payIn">
                <p>PAYMENT INFO</p>
                <label class="label">Payment Method :</label>
            </div>
            <div class="creditCardIn">
              <div fxLayout="row wrap">
                <div fxFlex="100%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>Card Number</mat-label>
                      <div class="inputDesign">
                        <ngx-stripe-card-number [options]="cardNumberOption" (change)="onChange($event)"></ngx-stripe-card-number>
                      </div>
                      <div *ngIf="!!carderrorMessage" class="error-message">{{carderrorMessage}}</div>
                  </div>
                </div>  
                <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>Expiration Date</mat-label>
                    <div class="inputDesign">
                      <ngx-stripe-card-expiry [options]="expiryOption" (change)="onChange($event)"></ngx-stripe-card-expiry>
                    </div>
                  </div>
                </div>
                <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                  <div class="matField" fxFlex="100%">
                    <mat-label>CVC Code</mat-label>
                    <div class="inputDesign">
                      <ngx-stripe-card-cvc [options]="cardOptions" (change)="onChange($event)"></ngx-stripe-card-cvc>
                    </div>
                    <div *ngIf="!!cvcerrorMessage" class="error-message">{{cvcerrorMessage}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-1 register-btn p-1">
          <button mat-raised-button color="primary" id="register" (click)="onRegisterFormSubmit()">Register</button>
        </div>
      </div>
      </ng-container>
      <ng-container *ngIf="!!featureTags && featureTags['ftag_cod_and_other_payment_for_sf']">
        <mat-accordion [multi]="false">
          <mat-expansion-panel #registerccpanel [expanded]="selectedPaymentMethod === 'Credit Card'" hideToggle>
            <mat-expansion-panel-header class="card-header" (click)="onPaymentMethodChange('Credit Card')">
              <mat-radio-button color="primary" [checked]="selectedPaymentMethod === 'Credit Card'">
                Credit Card
              </mat-radio-button>
              <mat-icon class="arrow-icon" *ngIf="registerccpanel.expanded">keyboard_arrow_up</mat-icon>
              <mat-icon class="arrow-icon" *ngIf="!registerccpanel.expanded">keyboard_arrow_down</mat-icon>
            </mat-expansion-panel-header>
        
            <!-- Panel Content -->
            <div class="order-items" *ngIf="selectedPaymentMethod === 'Credit Card'">
              <div class="tabContent" *ngIf="!!paymentMethod && paymentMethod ==='authorize_net'">
                <form [formGroup]="creditCardForm" >     
                  <div fxLayout="row wrap">
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>Billing Address</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input matInput placeholder="Billing Address" formControlName="address" id="card_address" required>
                          <mat-error *ngIf="creditCardForm.controls.address.errors?.required">Billing Address is required</mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>City</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input matInput placeholder="City" formControlName="city" id="card_city" required>
                          <mat-error *ngIf="creditCardForm.controls.city.errors?.required">City is required</mat-error>
                          <mat-error *ngIf="creditCardForm.controls.city.hasError('validation')">
                              {{creditCardForm.controls.city.errors.message}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>State</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input matInput placeholder="State" formControlName="state" id="card_state">
                          <mat-error *ngIf="creditCardForm.controls.state.errors?.required">State is required</mat-error>
                          <mat-error *ngIf="creditCardForm.controls.state.hasError('validation')">
                              {{creditCardForm.controls.state.errors.message}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>Zip Code</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input inputmode="numeric" matInput (keypress)="validateNumber($event)"
                          (paste)="validatePaste($event)" placeholder="Zip Code" pattern="[0-9]*" formControlName="zipcode" id="zipcode"> 
                          <mat-error *ngIf="creditCardForm.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                          <mat-error *ngIf="creditCardForm.controls.zipcode.hasError('validation')">
                              {{creditCardForm.controls.zipcode.errors.message}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="100" class="px-1 payIn">
                        <p>PAYMENT INFO</p>
                        <label class="label">Payment Method :</label>
                    </div>
                    <div class="creditCardIn">
                      <div fxLayout="row wrap">
                        <div fxFlex="100%" class="px-1">
                          <div class="matField" fxFlex="100%">
                            <mat-label>Card number</mat-label>
                            <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100">
                              <input matInput placeholder="Card number" formControlName="number" id="card_number" type="tel" 
                                        autocomplete="cc-number" maxlength="19" (input)="changeCreditCardnumber($event)" ccNumber cc-eager-type> 
                              <mat-error *ngIf="creditCardForm.controls.number.errors?.required">Credit Card number is required</mat-error>
                              <mat-error *ngIf="!creditCardForm.controls.number.errors?.required && creditCardForm.controls.number.errors?.ccNumber">Invalid credit card number</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.number.hasError('validation')">
                                  {{creditCardForm.controls.number.errors.message}}
                              </mat-error>
                          </mat-form-field>
                          </div>
                        </div>  
                        <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                          <div class="matField" fxFlex="100%">
                            <mat-label>Expiration Date</mat-label>
                            <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100 card-details">
                              <input matInput placeholder="MM/YY" formControlName="expiry" id="card_expiry" (input)="onExpirationInput($event)" type="tel" autocomplete="cc-exp" ccExp maxlength="5">
                              <mat-error *ngIf="creditCardForm.controls.expiry.errors?.required">Expiration Date is required</mat-error>
                              <mat-error *ngIf="!creditCardForm.controls.expiry.errors?.required && creditCardForm.controls.expiry.errors?.expDate">Invalid expiration date</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.expiry.errors?.maxlength">Year must contain 2 digits only</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.expiry.hasError('validation')">
                                  {{creditCardForm.controls.expiry.errors.message}}
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                        <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                          <div class="matField" fxFlex="100%">
                            <mat-label>CVC Code</mat-label>
                            <mat-form-field appearance="outline" FloatLabelType="never"  class="w-100">
                              <input matInput placeholder="CVC Code" formControlName="cvc" id="card_cvc" type="password"
                                  inputmode="numeric" autocomplete="off" ccCVC maxlength="4" pattern="[0-9]*"> 
                              <mat-error *ngIf="creditCardForm.controls.cvc.errors?.required">CVC is required</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.cvc.errors?.minlength">CVC must be at least 3 digits</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.cvc.errors?.invalid">Invalid CVC code</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.cvc.hasError('numberOnly')">CVC number can only contain digits.</mat-error>
                              <mat-error *ngIf="creditCardForm.controls.cvc.hasError('validation')">
                                  {{creditCardForm.controls.cvc.errors.message}}
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>              
              </div>
              <div class="tabContent" *ngIf="!!paymentMethod && paymentMethod ==='stripe'">
                <form [formGroup]="stripecreditCardForm" ngxStripeCardGroup
                (ngSubmit)="stripeAddCreditCard(stripecreditCardForm)" novalidate [elementsOptions]="elementsOptions">     
                  <div fxLayout="row wrap">
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>Billing Address</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input matInput placeholder="Billing Address" formControlName="address" id="card_address" required>
                          <mat-error *ngIf="creditCardForm.controls.address.errors?.required">Billing Address is required</mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>City</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input matInput placeholder="City" formControlName="city" id="card_city" required>
                          <mat-error *ngIf="creditCardForm.controls.city.errors?.required">City is required</mat-error>
                          <mat-error *ngIf="creditCardForm.controls.city.hasError('validation')">
                              {{creditCardForm.controls.city.errors.message}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>State</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input matInput placeholder="State" formControlName="state" id="card_state">
                          <mat-error *ngIf="creditCardForm.controls.state.errors?.required">State is required</mat-error>
                          <mat-error *ngIf="creditCardForm.controls.state.hasError('validation')">
                              {{creditCardForm.controls.state.errors.message}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-1">
                      <div class="matField" fxFlex="100%">
                        <mat-label>Zip Code</mat-label>
                        <mat-form-field appearance="outline" FloatLabelType="never" class="w-100">
                          <input inputmode="numeric" matInput (keypress)="validateNumber($event)"
                          (paste)="validatePaste($event)" placeholder="Zip Code" pattern="[0-9]*" formControlName="zipcode" id="zipcode"> 
                          <mat-error *ngIf="creditCardForm.controls.zipcode.errors?.required">Zip Code is required</mat-error>
                          <mat-error *ngIf="creditCardForm.controls.zipcode.hasError('validation')">
                              {{creditCardForm.controls.zipcode.errors.message}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="100" class="px-1 payIn">
                        <p>PAYMENT INFO</p>
                        <label class="label">Payment Method :</label>
                    </div>
                    <div class="creditCardIn">
                      <div fxLayout="row wrap">
                        <div fxFlex="100%" class="px-1">
                          <div class="matField" fxFlex="100%">
                            <mat-label>Card Number</mat-label>
                              <div class="inputDesign">
                                <ngx-stripe-card-number [options]="cardNumberOption" (change)="onChange($event)"></ngx-stripe-card-number>
                              </div>
                              <div *ngIf="!!carderrorMessage" class="error-message">{{carderrorMessage}}</div>
                          </div>
                        </div>  
                        <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                          <div class="matField" fxFlex="100%">
                            <mat-label>Expiration Date</mat-label>
                            <div class="inputDesign">
                              <ngx-stripe-card-expiry [options]="expiryOption" (change)="onChange($event)"></ngx-stripe-card-expiry>
                            </div>
                          </div>
                        </div>
                        <div fxFlex="100%" fxFlex.gt-sm="50%" class="px-1">
                          <div class="matField" fxFlex="100%">
                            <mat-label>CVC Code</mat-label>
                            <div class="inputDesign">
                              <ngx-stripe-card-cvc [options]="cardOptions" (change)="onChange($event)"></ngx-stripe-card-cvc>
                            </div>
                            <div *ngIf="!!cvcerrorMessage" class="error-message">{{cvcerrorMessage}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>                
              </div>
            </div>
          </mat-expansion-panel>
        
          <mat-expansion-panel #registercodpanel *ngIf="!!paymentCashOnDelivery && !!paymentCashOnDelivery.is_sf_active" [expanded]="selectedPaymentMethod === 'Cash On Delivery'" hideToggle>
            <mat-expansion-panel-header class="card-header" (click)="onPaymentMethodChange('Cash On Delivery')">
              <mat-radio-button color="primary" [checked]="selectedPaymentMethod === 'Cash On Delivery'">
                Cash On Delivery
              </mat-radio-button>
              <mat-icon class="arrow-icon" *ngIf="registercodpanel.expanded">keyboard_arrow_up</mat-icon>
              <mat-icon class="arrow-icon" *ngIf="!registercodpanel.expanded">keyboard_arrow_down</mat-icon>
            </mat-expansion-panel-header>
              
            <!-- Panel Content -->
            <div class="order-items" *ngIf="selectedPaymentMethod === 'Cash On Delivery'">
              <p>Pay later at your doorstep with Cash on Delivery.</p>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <div fxLayout="row" fxLayoutAlign="center center" class="mt-1 register-btn p-1">
          <button mat-raised-button color="primary" id="register" (click)="onRegisterFormSubmit()">Register</button>
        </div>
      </ng-container>
    </ng-container>
    </mat-tab>
  </mat-tab-group>
</div>